var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st0",
    d: "M49.95,36.88c-8.26,0-16.51,0-24.77,0c-1.31,0-1.47-0.17-1.48-1.45c0-0.97,0-1.94-0.02-2.9 c-0.01-0.63,0.23-1,0.84-1.22c4.56-1.65,9.12-3.33,13.68-4.99c3.65-1.33,7.31-2.66,10.96-4c0.54-0.2,1.04-0.23,1.59-0.03 c8.13,2.98,16.26,5.94,24.39,8.92c1.13,0.41,1.15,0.45,1.16,1.67c0.01,0.92,0.01,1.84,0,2.75c0,1.01-0.27,1.27-1.29,1.27 C66.66,36.88,58.3,36.88,49.95,36.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st0",
    d: "M50.08,68.86c9.72,0,19.45,0,29.17,0c1.46,0,1.63,0.17,1.64,1.62c0,2.3,0,2.3-2.3,2.3c-19.3,0-38.6,0-57.9,0 c-1.31,0-1.57-0.26-1.57-1.55c0-2.35,0-2.35,2.39-2.35C31.03,68.87,40.55,68.87,50.08,68.86C50.08,68.87,50.08,68.86,50.08,68.86z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st0",
    d: "M50.08,62.04c8.18,0,16.37,0,24.55,0c1.37,0,1.58,0.25,1.61,1.59c0.06,2.5-0.32,2.31-2.32,2.31 c-16.17-0.01-32.33,0-48.5,0c-1.4,0-1.61-0.25-1.64-1.64c-0.05-2.46,0.28-2.26,2.27-2.26C34.06,62.05,42.07,62.04,50.08,62.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st0",
    d: "M71.49,49.47c0,2.75,0,5.51,0,8.26c0,1.01-0.32,1.33-1.33,1.33c-2.49,0-4.97,0-7.46,0 c-0.8,0-1.19-0.37-1.2-1.18c-0.01-5.61-0.01-11.21,0-16.82c0-0.82,0.37-1.19,1.19-1.19c2.54-0.01,5.07-0.01,7.61,0 c0.85,0,1.18,0.37,1.18,1.25C71.49,43.92,71.49,46.69,71.49,49.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st0",
    d: "M28.52,49.45c0-2.76,0-5.51,0-8.27c0-0.97,0.32-1.3,1.29-1.3c2.46-0.01,4.93-0.01,7.39,0 c0.94,0,1.3,0.37,1.3,1.32c0,5.54,0.01,11.07,0,16.61c0,0.89-0.37,1.26-1.28,1.26c-2.49,0-4.98,0-7.46,0 c-0.9,0-1.24-0.35-1.24-1.27C28.52,55.01,28.52,52.23,28.52,49.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st0",
    d: "M45.02,49.39c0-2.7,0-5.41,0-8.11c0-1.12,0.28-1.39,1.41-1.4c2.39,0,4.77-0.01,7.16-0.01 c1.09,0,1.37,0.27,1.37,1.36c0.01,5.5,0.02,11.01,0.02,16.51c0,1.02-0.32,1.32-1.35,1.32c-2.39,0-4.77,0-7.16,0 c-1.2,0-1.46-0.25-1.46-1.42C45.03,54.89,45.03,52.14,45.02,49.39z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartBalance);
export default __webpack_public_path__ + "static/media/start_balance.e0ac0f2cbbc502a59851b02a1ebe453f.svg";
export { ForwardRef as ReactComponent };